import { ProductType } from '@/shared/enums';

const DEFAULT_LABELS = {
  [ProductType.VOD]: 'movies',
  [ProductType.SERIAL]: 'series',
  [ProductType.EPISODE]: 'series',
  [ProductType.LIVE]: 'live_tv',
  [ProductType.PROGRAMME]: 'live_tv',
  [ProductType.CATCH_UP]: 'live_tv',
  [ProductType.CLIP]: 'clips',
};

export default (product) => {
  if (!product.id) {
    return '';
  }

  return product.mainCategory?.label || DEFAULT_LABELS[product.type] || '';
};
